import { useEffect, useState } from "react";


export default function useImageFetch(num: string| null ) {
  const [data, setData] = useState<string[]>();

  const currentUrl = window.location.href;

  const getBackendUrl = () => {
    const isDev = /-dev\.logisteq.com/.test(currentUrl);
    const isQa = /-qa\.logisteq.com/.test(currentUrl);
    const isLocalhost = /localhost/.test(currentUrl);
  
    const urls = {
      dev: 'https://sweettracker.logisteq.com/lmd/images/dev',
      qa: 'https://sweettracker.logisteq.com/lmd/images/qa',
      localhost: 'http://localhost:3526/lmd/images/dev',
      default: 'https://sweettracker.logisteq.com/lmd/images',
    };  
    const url = urls[isDev ? 'dev' : isQa ? 'qa' : isLocalhost ? 'localhost' : 'default'];  
    console.log(`currentUrl => ${currentUrl} , backendurl => ${url}`);    
    return url;
  }

  useEffect(() => {    
    const backendUrl = getBackendUrl();
    fetch(`${backendUrl}/${num}`)
      .then(res => {
        return res.json();
      })
      .then(data => {
        setData(data);
      });
  }, [num]);

  return data;
}
